import { Injectable } from '@angular/core';

import { UserService } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class ZendeskLiveChatResourceService {
    constructor(
        private api: ApiService,
        private user: UserService,
    ) {}
    getInitValuesZendeskChat(): Observable<any> {
        let skipJwt = this.tokenSetup();
        return this.api.get('zendeskLiveChat/GetChatConfig?isCashier=false&skipJwt=' + skipJwt + '&skipChatbotApi=true');
    }

    getSprinklrSettings(data: any): Observable<any> {
        data.queryParams.skipJwt = this.tokenSetup();
        return this.api.post('zendeskLiveChat/GetSprinklrSettings', data);
    }

    private tokenSetup() {
        let skipJwt = false;
        if (this.user.accountId) {
            if (
                sessionStorage.getItem('zd-jwt-' + this.user.accountId) &&
                this.IsJwtExpired(sessionStorage.getItem('zd-jwt-' + this.user.accountId))
            ) {
                sessionStorage.removeItem('zd-jwt-' + this.user.accountId);
            } else if (sessionStorage.getItem('zd-jwt-' + this.user.accountId)) skipJwt = true;
        }
        return skipJwt;
    }

    private IsJwtExpired(token: any) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join(''),
        );

        const res = JSON.parse(jsonPayload);
        if (res.exp) {
            if (new Date(res.exp * 1000).getTime() - new Date().getTime() <= 30000) {
                return true;
            }
        }
        return false;
    }
}

//getChatConfig()
//getJwtToken()
